import React from 'react'

export default function ErrorPage() {
  return (
    <div style={{ textAlign: 'center',marginTop: "15%"}}>
        <h3>Error 404 <br/> Page not Found</h3>
    </div>
  )
}
